import React from 'react'
import ReactDOM from 'react-dom'
import 'styles/index.scss'
import App from 'pages'
import reportWebVitals from './reportWebVitals'
import 'lib/init'
// import SubscriptionBanner from 'components/SubcriptionBanner'

const dsessionId = localStorage.getItem('api_refresh_key') | "not found";
if (dsessionId) {
  console.log("sessionObject Found: "+ dsessionId );
}else{
  console.log("sessionObject NOT FOUND")
}

ReactDOM.render(
  <React.StrictMode>
    {/* <SubscriptionBanner sessionId={dsessionId}/> */}
    <App />
  </React.StrictMode>,
  document.getElementById('root')
)


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()